import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Contemporary_Period_-_Social_Movements_e.g._Civil_Rights_LGBTQ+.png';

function HistoryPageSocialMovements() {
  return (
    <TopicPage
      topicKey="Social Movements (e.g., Civil Rights, LGBTQ+)"
      title="History: Social Movements"
      backgroundImage={bg}
      startRoute="/History-Social-Movements-Go"
      scrollLabels={[
        "Civil Rights Movement",
        "Feminist and LGBTQ+ Rights",
        "Environmental and Youth Activism"
      ]}
      backRoute="/history-contemporary"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageSocialMovements;
